export default function getTailwindBgColor(input) {
    const colors = [
      'bg-red-500',
      'bg-green-500',
      'bg-blue-500',
      'bg-yellow-500',
      'bg-pink-500',
      'bg-purple-500',
      'bg-indigo-500',
      'bg-teal-500',
      'bg-orange-500',
      'bg-lime-500',
      'bg-amber-500',
      'bg-emerald-500',
      'bg-cyan-500',
      'bg-sky-500',
      'bg-violet-500',
      'bg-fuchsia-500',
      'bg-rose-500',
      'bg-azure-500',
      'bg-turquoise-500',
      'bg-peach-500',
      'bg-lemon-500',
      'bg-grape-500',
      'bg-tomato-500',
      'bg-chocolate-500',
      'bg-slate-500',
      'bg-zinc-500',
      'bg-neutral-500',
      'bg-stone-500',
      'bg-red-600', // Adding a few different intensities
      'bg-green-600',
      'bg-blue-600',
      // ...you can continue with more colors and intensities
    ];
  
    // Ensure the input is positive and use modulo to cycle through the array
    const positiveInput = Math.abs(input);
    const index = positiveInput % colors.length;
  
    return colors[index];
  }
  